<template>
  <div class="edit-user-machine">
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      class="dialogClass"
      :title="userEquipment.id ? $t('editUserMachine.edit') : $t('editUserMachine.add')"
      :visible.sync="dialogUserMachine"
      width="800px"
      top="6vh"
      @closed="closeDialog"
      :close-on-click-modal="false"
    >
      <div v-loading="loadingForm" :element-loading-text="$t('common.request')">
        <el-form
          :label-position="labelPosition"
          :rules="rules"
          ref="userEquipment"
          label-width="80px"
          :model="userEquipment"
        >
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item :label="$t('editUserMachine.equipmentNo')" prop="equipmentNo">
                <el-input
                  v-model="userEquipment.equipmentNo"
                  :disabled="true"
                  readonly
                  :placeholder="$t('editUserMachine.pMachineNo')"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('editUserMachine.name')" prop="equipmentName">
                <el-input
                  v-model="userEquipment.equipmentName"
                  :placeholder="$t('editUserMachine.pName')"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('editUserMachine.teamId')" prop="teamId">
                <el-select
                  v-model="userEquipment.teamId"
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  filterable
                  clearable
                  :placeholder="$t('editUserMachine.pUserMachineGroupId')"
                >
                  <el-option
                    v-for="item in machineGroup"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item :label="$t('editUserMachine.servicePhone')" prop="servicePhone">
                <el-input
                  v-model="userEquipment.servicePhone"
                  :placeholder="$t('editUserMachine.pServicePhone')"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item :label="$t('editUserMachine.address')" prop="locale">
                <el-input
                  v-model="userEquipment.locale"
                  :placeholder="$t('editUserMachine.pAddress')"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('editUserMachine.enableStatus')" prop="enableStatus">
                <el-select
                  v-model="userEquipment.enableStatus"
                  filterable
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('editUserMachine.pIsEnable')"
                >
                  <el-option v-for="item in yesNo" :key="item.id" :label="item.label" :value="+item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item :label="$t('editUserMachine.notes')">
                <el-input type="textarea" :rows="6" v-model="userEquipment.notes"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('')" size="small">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" :disabled="loadingForm" @click="submitForm('userEquipment')" size="small">{{
          $t("common.definite")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "EditUserMachine",
    props: {
      dialogUserMachine: Boolean,
      userEquipment: Object,
      machineGroup: Array,
      yesNo: Array,
      deviceMode: Array
    },
    data() {
      return {
        labelPosition: "top",
        loadingForm: false,
        rules: {},
        isbuy: 1
      };
    },
    mounted() {
      this.userEquipment;
    },
    methods: {
      selectChanged(value) {
        if (value == 2) {
          this.isbuy = 1;
        } else {
          this.isbuy = 0;
        }
      },
      closeDialog() {
        this.clearValidate("userEquipment");
        // this.$toolUtil.clearForm(this.userEquipment);
        this.cancel("");
      },
      cancel(state, code) {
        this.$emit("cancel", false, state, code);
      },
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.loadingForm = true;
            this.$api
              .request(this.$url.UserMachine.update, this.$method.put, this.userEquipment)
              .then(res => {
                if (res.code === 0) {
                  this.$notify({
                    title: this.$t("common.tip"),
                    message: this.$t("addMachine.up"),
                    type: "success"
                  });
                  this.cancel("update");
                }
                this.loadingForm = false;
              })
              .catch(() => {
                this.loadingForm = false;
              });
          }
        });
      },
      clearValidate(formName) {
        this.$refs[formName].clearValidate();
      }
    }
  };
</script>

<style lang="scss" scoped>
  ::v-deep .el-dialog {
    border-radius: 6px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial,
      sans-serif;
    .el-dialog__header {
      padding: 15px 15px 15px 20px;
      background-color: #409eff;
      border-radius: 5px 5px 0 0;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: white;
    }
    .el-dialog__title {
      color: white;
    }
    .el-dialog__body {
      padding: 20px 20px 0 20px;
    }
    .el-dialog__footer {
      padding: 20px;
    }
    .el-form--label-top .el-form-item__label {
      padding: 0;
    }
    .el-form-item {
      margin: 0;
    }
    .el-dialog__headerbtn {
      top: 20px;
      right: 15px;
    }
  }
</style>
